<template>
    <div>
        <el-form :rules="rules" ref="ruleForm" :model="editData" label-width="110px" size="mini">
            <el-form-item prop="khid"  class="lable-width" :label="$t('form_warehouse')" :rules="{required: true, message: '请选择仓库', trigger: 'blur'}">
                <el-select
                        size="mini"
                        style="margin-left: 0px;position: relative"
                        @change="ckchange"
                        class="input-width"
                        :disabled="ckHide"
                        v-model="editData.khid"
                        filterable>
                    <el-option
                            v-for="item in ckdata"
                            :key="item.warehouseId"
                            :label="item.warehouseName"
                            :value="item.warehouseId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="name" class="lable-width" label="库区名称" :rules="{required: true, message: '请输入库区名', trigger: 'blur'}">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" placeholder="请输入"  clearable v-model="editData.name" :disabled="isHide"></el-input>
                </div>
            </el-form-item>
            <el-form-item prop="mj" class="lable-width" label="面积(m²)" >
                <div style="margin-left: 0px;position: relative">
                    <el-input-number class="input-width" label="123" placeholder="请输入面积" :controls="false" :min="0" clearable v-model="editData.mj" :disabled="isHide"></el-input-number>
                </div>
            </el-form-item>

            <el-form-item prop="rl" class="lable-width" label="容量(t)">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" placeholder="请输入"  disabled clearable v-model="editData.rl"></el-input>
                </div>
            </el-form-item>

            <el-form-item prop="note" class="lable-width" :label="$t('form_notes')">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" placeholder="请输入"  clearable v-model="editData.note" :disabled="isHide"></el-input>
                </div>
            </el-form-item>

            <el-form-item prop="createime" class="lable-width" label="发布时间">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" disabled  clearable v-model="editData.createTime"></el-input>
                </div>
            </el-form-item>

            <el-form-item prop="lruName" class="lable-width" label="录入人姓名">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" disabled  clearable v-model="editData.lruName"></el-input>
                </div>
            </el-form-item>
            <el-form-item  label="是否启用">
                <div style="margin-left: 34px">
                    <el-radio v-model="editData.state" :label="1">启用</el-radio>
                    <el-radio v-model="editData.state" :label="0">不启用</el-radio>
                </div>
            </el-form-item>

            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit(editData)" :disabled="isDisable">保存</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'reviseReservoirArea',
        props:{
            editData1:{
                type:Object
            },
            ckid:{
                type:Number
            },
            title:{
                type:String
            },
        },
        data(){
            return{
                isDisable:false,
                timeStamp:'',
                validateKey:'',
                ckdata:{},
                editData:this.editData1,
                isHide:false,
                ckHide:true,
                rules: {
                    mj: [
                        {required: true, message: '请输入面积', trigger: 'blur'},
                        // {pattern: /^-?\d+(\.\d+)?$/, message: "请输入合法面积", trigger: "blur" },
                        {pattern: /^[0-9]+\.{0,1}[0-9]{0,15}$/, message: "请输入大于0的数字", trigger: "blur" },
                        {pattern: /^\d+(\.\d{1,5})?$/, message: "请保留五位小数", trigger: "blur" }
                    ]

                }

            }
        },
        watch:{
        },
        mounted(){
            this.selectWarehouse()
            if(this.title=='编辑'){
                this.isHide=true
                this.getDetails()
            }
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            ckchange(e){
                this.editData.khid=e
                this.$forceUpdate()
            },
            close(){
                this.$emit('close')
            },
            onSubmit(editData){
                this.save()
            },

            //仓库下拉
            async selectWarehouse(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id) {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                }
                let res = await API.selectWarehouse(params);
                if (res.code == 1) {
                    this.ckdata = res.data
                    let arr =  res.data;
                    arr.forEach(item=>{
                        if(item.warehouseId==this.editData1.khid){
                            this.editData.khid=item.warehouseId
                        }
                    })
                    // this.editData.khid=arr[0].warehouseId

                    this.ckHide=false
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //库区详情
            async getDetails(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                }
                let res = await API.getDetails(params);
                if (res.code == 1) {
                    this.editData=res.data
                    // this.tableData.forEach(item=>{
                    //     item.createTime=item.createTime.substring(0,19)
                    // })
                    this.isHide=false
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //库区保存
            async save(val) {
                // rules
                if(this.editData.khid==''){
                    this.$message({
                        message: '请选择仓库名称',
                        type: 'error'
                    });
                    return
                }
                if(this.editData.name==''){
                    this.$message({
                        message: '请输入库区名称',
                        type: 'error'
                    });
                    return
                }
                // console.log(this.editData.mj,'this.editData.mj')
                if(this.editData.mj===''||this.editData.mj===undefined||this.editData.mj===null){
                    this.$message({
                        message: '请输入面积',
                        type: 'error'
                    });
                    return
                }
                if(this.editData.mj<0){
                    this.$message({
                        message: '请输入大于0的面积',
                        type: 'error'
                    });
                    return
                }
                if(isNaN(this.editData.mj)){
                    this.$message({
                        message: '请输入数字',
                        type: 'error'
                    });
                    return
                }
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    name:this.editData.name,
                    mj:this.editData.mj,
                    rl:this.editData.rl,
                    note:this.editData.note,
                    state:this.editData.state,
                    khid:this.editData.khid,
                }
                this.isDisable = true
                let res = await API.save(params);
                if (res.code == 1) {
                    this.isDisable = false
                    this.$emit("close")
                    this.$emit('getList')
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.isDisable = false
                    this.$message.error(res.message);
                }
            },


        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>